import React, { ReactNode, useState } from 'react';
import { useQuery } from '@apollo/client';

import { SalesCenterPageProps } from '../../types';
import { dealSheetConfigurationApi } from '../../api';

interface Props {
  children: (renderProps: SalesCenterPageProps) => ReactNode;
}

export const SalesCenterApiContainer = ({ children }: Props) => {
  const [activeConfigId, setActiveConfigId] = useState<number>(0);

  const { data, loading } = useQuery(dealSheetConfigurationApi.getConfigs, {
    onCompleted() {
      setActiveConfigId(0);
    },
  });

  const listOfConfigs = data?.result?.list ?? [];
  const activeConfig = listOfConfigs[activeConfigId] ?? null;

  return (
    <>{children({ listOfConfigs, config: activeConfig, onConfigureWorkflow: setActiveConfigId, isLoading: loading })}</>
  );
};
